import { Outlet } from "react-router-dom";
import "../css/layouts/blanklayout.css"; 

export default function BlankLayout() {
    return (
        <div className="blanklayout-root">
            <div className="blanklayout-shape-left" />
            <div className="blanklayout-shape-right" />

            <Outlet />
        </div>
    );
}
